import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { default as RaisedButton } from 'material-ui/RaisedButton'
import { default as Divider } from 'material-ui/Divider'
import { default as Dialog } from 'material-ui/Dialog'
import { default as FlatButton } from 'material-ui/FlatButton'
import { default as SelectField } from 'material-ui/SelectField'
import { default as MenuItem } from 'material-ui/MenuItem'
import { default as DropDownMenu } from 'material-ui/DropDownMenu'
import { default as DatePicker } from 'material-ui/DatePicker'
import moment from 'moment'

import TimePicker from 'material-ui/TimePicker'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import Buildings from '../containers/Buildings'

import {
  fetchUsersReports,
  fetchBookingReports,
  fetchProgramReports,
  fetchBuildingsReports,
  fetchBuildings,
  fetchActiveUsersReports,
  fetchNewUsersReports,
  fetchCommunityReports,
  showNewUserReportsDialog,
  showActiveUserReportsDialog,
  closeUserReportsDialog,
  updateDateStart,
  updateDateEnd,
  closeReceiveNewsletterReportsDialog,
  showReceiveNewsletterReportsDialog,
  selectActivateBuilding,
  updateActiveBuilding,
  updateFilter
} from '../actions/reports'
import { fetchUsers } from '../actions/users'

class Reports extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {
    buildings: [],
    showNewUserReportsDialog: false,
    showReceiveNewsletter: false
    // filter: {
    //   buildingId: ' '
    // }
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchBuildings())
    dispatch(fetchUsers())
    document.title = 'Reports - Admin - Better Spaces'
  }

  showFetchedUsersReports(event) {
    const { dispatch } = this.props
    dispatch(fetchUsersReports(event))
  }

  showFetchedBookingReports() {
    const { dispatch } = this.props
    dispatch(fetchBookingReports())
  }

  showFetchedProgramReports() {
    const { dispatch } = this.props
    dispatch(fetchProgramReports())
  }
  showFetchedCommunityReports(event, index, value) {
    const { dispatch } = this.props

    dispatch(fetchCommunityReports(this.props.newsletterBuildingId))

    dispatch(closeReceiveNewsletterReportsDialog())
  }

  showSelectedBuilding(event, index, value) {
    const { dispatch } = this.props
    dispatch(selectActivateBuilding(value))
  }

  showFetchedBuildingsReports(event, index, value) {
    const { dispatch } = this.props
    dispatch(fetchBuildingsReports(this.props.selectedBuildingId, event))
  }

  showFetchedNewUsersReports() {
    const { dispatch } = this.props

    let startDate = moment(this.props.valueStart)
    startDate.hours(0)
    startDate.minutes(0)
    startDate.seconds(1)

    let endDate = moment(this.props.valueEnd)
    endDate.add(1, 'days')
    endDate.hours(0)
    endDate.minutes(0)
    endDate.seconds(1)

    dispatch(fetchNewUsersReports(startDate, endDate))
    dispatch(closeUserReportsDialog())
  }

  showFetchedActiveUsersReports() {
    const { dispatch } = this.props

    let startDate = moment(this.props.valueStart)
    startDate.hours(0)
    startDate.minutes(0)
    startDate.seconds(1)

    let endDate = moment(this.props.valueEnd)
    endDate.add(1, 'days')
    endDate.hours(0)
    endDate.minutes(0)
    endDate.seconds(1)

    dispatch(fetchActiveUsersReports(startDate, endDate))
    dispatch(closeUserReportsDialog())
  }

  showNewReportsDialog() {
    const { dispatch } = this.props
    dispatch(showNewUserReportsDialog())
  }

  showActiveReportsDialog() {
    const { dispatch } = this.props
    dispatch(showActiveUserReportsDialog())
  }

  closeReportsDialog() {
    const { dispatch } = this.props
    dispatch(closeUserReportsDialog())
  }

  closeReceiveNewsletterReportsDialog() {
    const { dispatch } = this.props
    dispatch(closeReceiveNewsletterReportsDialog())
  }

  showReceiveNewsletterReports() {
    const { dispatch } = this.props
    dispatch(showReceiveNewsletterReportsDialog())
  }

  updateDateStartDate(name, event, date) {
    const { dispatch } = this.props
    dispatch(updateDateStart(name, date))
    console.log(date)
  }

  updateDateEndDate(name, event, date) {
    const { dispatch } = this.props
    dispatch(updateDateEnd(name, date))
    console.log(date)
  }

  updateActiveBuilding(event, index, value) {
    const { dispatch } = this.props
    dispatch(updateActiveBuilding(value))
  }

  // updateFilter(name, event, index, value) {
  //   const { dispatch } = this.props
  //   dispatch(updateFilter(name, value))
  // }

  render() {
    let buildings = this.props.buildings
    // const buildings = this.props.buildings
    // if (this.props.filter.buildingId !== ' ') {
    //   buildings = buildings.filter(user => {
    //     return user.building && user.building._id === this.props.filter.buildingId
    //   })
    // }
    const activeUserReports = [
      <FlatButton
        id='DOWNLOAD ACTIVE USERS'
        label='DOWNLOAD ACTIVE USERS'
        primary={true}
        onClick={this.showFetchedActiveUsersReports.bind(this)}
      />,
      <FlatButton label='Cancel' primary={true} onClick={this.closeReportsDialog.bind(this)} />
    ]

    const newUserReports = [
      <FlatButton label='Cancel' primary={true} onClick={this.closeReportsDialog.bind(this)} />,
      <FlatButton
        id='DOWNLOAD NEW USERS'
        label='DOWNLOAD NEW USERS'
        primary={true}
        onClick={this.showFetchedNewUsersReports.bind(this)}
      />
    ]

    const receiveNewsletterReports = [
      <FlatButton label='Cancel' primary={true} onClick={this.closeReceiveNewsletterReportsDialog.bind(this)} />,
      <FlatButton
        id='Download community manager newsletter email list'
        label='Download community manager newsletter email list'
        primary={true}
        onClick={this.showFetchedCommunityReports.bind(this)}
      />
    ]

    return (
      <div>
        <Dialog actions={newUserReports} title='User Reports' modal={true} open={this.props.showNewUserReportsDialog}>
          <DatePicker
            hintText='Start Date'
            name='startDate'
            value={this.props.valueStart}
            onChange={this.updateDateStartDate.bind(this, 'startDate')}
          />
          <br />
          <DatePicker
            hintText='End Date'
            name='endDate'
            value={this.props.valueEnd}
            onChange={this.updateDateEndDate.bind(this, 'endDate')}
          />
        </Dialog>

        <Dialog
          actions={activeUserReports}
          title='User Reports'
          modal={true}
          open={this.props.showActiveUserReportsDialog}>
          <DatePicker
            hintText='Start Date'
            name='startDate'
            value={this.props.valueStart}
            onChange={this.updateDateStartDate.bind(this, 'startDate')}
          />
        </Dialog>

        <Dialog
          actions={receiveNewsletterReports}
          title='Select Building'
          modal={true}
          open={this.props.showReceiveNewsletter}>
          <SelectField
            floatingLabelText='Building'
            value={this.props.newsletterBuildingId}
            onChange={this.showSelectedBuilding.bind(this)}
            // onChange = {this.showFetchedCommunityReports.bind(this)}
          >
            <MenuItem value={undefined} primaryText='' />
            {this.props.buildings.map((building, index) => (
              <MenuItem value={building._id} primaryText={building.name} />
            ))}
          </SelectField>
        </Dialog>

        <h1>Reports</h1>

        <RaisedButton
          label='Download bookings Report'
          primary={true}
          style={{ margin: 0, float: 'left', padding: '20px', boxShadow: 'white' }}
          onClick={this.showFetchedBookingReports.bind(this)}
        />
        <RaisedButton
          label='Download programs Report'
          primary={true}
          style={{ margin: 0, float: 'left', padding: '20px', boxShadow: 'white' }}
          onClick={this.showFetchedProgramReports.bind(this)}
        />
        <RaisedButton
          label='Download community manager newsletter email list'
          primary={true}
          style={{ margin: 0, float: 'left', padding: '20px', boxShadow: 'white' }}
          onClick={this.showReceiveNewsletterReports.bind(this)}
        />
        <br />
        <br />
        <br />
        <br />
        <br />
        <Divider />
        <h3>Users Reports by Building</h3>
        {/* {this.props.buildings.map(building => (
          // <h3>{building.name + ' Report'} </h3>
          <div>
            <RaisedButton
              label={building.name}
              primary={true}
              style={{ margin: 0, float: 'left', padding: '20px', boxShadow: 'white' }}
              onClick={this.showFetchedBuildingsReports.bind(this, building._id)}
            />
          </div>
        ))} */}

        {/* <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br /> */}
        <SelectField
          style={{ float: 'left' }}
          floatingLabelText='User Reports by Building'
          // value={this.props.filter.buildingId}
          // onChange={this.updateFilter.bind(this, 'buildingId')}
          onChange={this.updateActiveBuilding.bind(this)}
          value={this.props.selectedBuildingId}>
          <MenuItem value=' ' primaryText='All Buildings' />
          {buildings.map(building => (
            <MenuItem value={building._id} primaryText={building.name} />
          ))}
        </SelectField>
        <br />

        <RaisedButton
          label='Show anon users reports'
          primary={true}
          style={{ margin: 0, float: 'left', padding: '20px', border: 0, boxShadow: 'white' }}
          onClick={
            this.props.selectedBuildingId == ' '
              ? this.showFetchedUsersReports.bind(this, false)
              : this.showFetchedBuildingsReports.bind(this, false)
          }
        />
        {this.props.role.length > 2 && this.props.role.charAt(2) == '3' ? (
          <RaisedButton
            label='Show full users reports'
            primary={true}
            style={{ margin: 0, float: 'left', padding: '20px', border: 0, boxShadow: 'white' }}
            onClick={
              this.props.selectedBuildingId == ' '
                ? this.showFetchedUsersReports.bind(this, true)
                : this.showFetchedBuildingsReports.bind(this, true)
            }
          />
        ) : (
          <div />
        )}

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div>
          <RaisedButton
            label='Show active users'
            primary={true}
            style={{ margin: 0, float: 'left', padding: '20px', border: 0, boxShadow: 'white' }}
            onClick={this.showActiveReportsDialog.bind(this)}
          />

          <RaisedButton
            label='Show new users'
            primary={true}
            style={{ margin: 0, float: 'left', padding: '20px', border: 0, boxShadow: 'white' }}
            onClick={this.showNewReportsDialog.bind(this)}
          />
        </div>
        <Divider />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { isFetching } = state.reportsReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return {
      ...state.reportsReducer,
      ...state.buildingsReducer,
      role: state.usersReducer.role
    }
  }
}

export default connect(mapStateToProps)(Reports)



// WEBPACK FOOTER //
// ./src/containers/Reports.js